/**
 * Register the service worker. Production only — registering in dev would let the
 * SW cache Vite's HMR modules and break hot reload. On a later visit, when an
 * updated SW activates, we reload once to pick up fresh assets (the first install
 * never reloads, because there was no prior controller).
 */
export function registerSW() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener('load', () => {
    const hadController = !!navigator.serviceWorker.controller;
    void navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Check for a new version roughly hourly while the app stays open.
        setInterval(() => void reg.update(), 60 * 60 * 1000);
        reg.addEventListener('updatefound', () => {
          const next = reg.installing;
          if (!next) return;
          next.addEventListener('statechange', () => {
            if (next.state === 'activated' && hadController) window.location.reload();
          });
        });
      })
      .catch(() => {
        /* SW registration is best-effort; the app works without it. */
      });
  });
}
